import Chart from "chart.js";
import {
  collectLabelGroupOverlays,
  drawLabelGroupBands,
  drawLabelGroupSeparators,
  INCIDENTS_CHART_GROUPS_FLAG,
  INCIDENTS_CHART_ROWS_PER_CLASS,
} from "./incidentsChartGroupOverlay";

export const INCIDENTS_GROUP_PLUGIN_ID = "incidentsLabelGroups";

const paintLabelGroups = (chart: any, drawSeparators: boolean) => {
  if (!chart?.config?.options?.[INCIDENTS_CHART_GROUPS_FLAG]) {
    return;
  }

  const rowsPerClass = Number(
    chart.config.options[INCIDENTS_CHART_ROWS_PER_CLASS]
  );
  if (!Number.isFinite(rowsPerClass) || rowsPerClass <= 0) {
    return;
  }

  const ctx = chart.ctx as CanvasRenderingContext2D | undefined;
  if (!ctx) {
    return;
  }

  const { bands, separators } = collectLabelGroupOverlays(chart, rowsPerClass);
  if (bands.length === 0) {
    return;
  }

  if (drawSeparators) {
    drawLabelGroupSeparators(ctx, separators);
    return;
  }

  drawLabelGroupBands(ctx, bands);
};

const incidentsLabelGroupsPlugin = {
  id: INCIDENTS_GROUP_PLUGIN_ID,
  beforeDatasetsDraw(chart: any) {
    paintLabelGroups(chart, false);
  },
  afterDraw(chart: any) {
    paintLabelGroups(chart, true);
  },
};

const alreadyRegistered = Chart.plugins.getAll().some(
  (plugin: any) => plugin.id === INCIDENTS_GROUP_PLUGIN_ID
);

if (!alreadyRegistered) {
  Chart.plugins.register(incidentsLabelGroupsPlugin);
}

export default incidentsLabelGroupsPlugin;
